import React, { Fragment } from "react";
import { Row, Card, CardBody, CardTitle, Badge, Button } from "reactstrap";

import IntlMessages from "Util/IntlMessages";

import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";

function badges() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <BreadcrumbContainer
              heading={<IntlMessages id="menu.social" />}
            />
            <Separator className="mb-5" />
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12">
            <Card className="mb-4">
              <CardBody>
                <CardTitle>
                  <IntlMessages id="menu.badges" />
                </CardTitle>
                <Row>
                  <Colxx lg="6">
                    <p>
                      Default Bootstrap Badges: Please use <code> Badge</code>{" "}
                      tag, and <code> color="primary" </code>
                      for default badge and use and so on, please note that we
                      used .my for margin purposes only.
                    </p>
                    <Badge href="#" color="primary" className="mr-2 mb-2">
                      Primary
                    </Badge>
                    <Badge
                      href="#"
                      color="secondary"
                      className="mr-2 mb-2 text-white"
                    >
                      Secondary
                    </Badge>
                    <Badge href="#" color="success" className="mr-2 mb-2">
                      Success
                    </Badge>
                    <Badge href="#" color="danger" className="mr-2 mb-2">
                      Danger
                    </Badge>
                    <Badge
                      href="#"
                      color="warning"
                      className="mr-2 mb-2 text-white"
                    >
                      Warning
                    </Badge>
                    <Badge href="#" color="info" className="mr-2 mb-2">
                      Info
                    </Badge>
                    <Badge
                      href="#"
                      color="light"
                      className="mr-2 mb-2 text-dark"
                    >
                      Light
                    </Badge>
                    <Badge href="#" color="dark" className="mr-2 mb-2">
                      Dark
                    </Badge>
                    <p className="mt-3">
                      Custom Badges: Availble with different colors Please use
                      span tag, for example
                      <code> className="badge-reactify"</code>
                      for default badge, you can use .badge-blue for blue badge
                      and so on.
                    </p>
                    <Badge href="#" className="badge-reactify mr-2 mb-2">
                      Green
                    </Badge>
                    <Badge href="#" className="badge-aqua mr-2 mb-2">
                      Aqua
                    </Badge>
                    <Badge href="#" className="badge-brown mr-2 mb-2">
                      Brown
                    </Badge>
                    <Badge href="#" className="badge-dark-blue mr-2 mb-2">
                      Dark Blue
                    </Badge>
                    <Badge
                      href="#"
                      className="badge-light-green mr-2 mb-2 text-white"
                    >
                      Light Green
                    </Badge>
                    <Badge href="#" className="badge-sea  mr-2 mb-2 text-white">
                      Turquoise
                    </Badge>
                    <Badge
                      href="#"
                      className="badge-orange mr-2 mb-2 text-white"
                    >
                      Orange
                    </Badge>
                    <Badge
                      href="#"
                      className="badge-yellow mr-2 mb-2 text-white"
                    >
                      Yellow
                    </Badge>

                    {/* Badges with icons */}

                    <p className="mt-3">Badges with icons</p>

                    <Badge href="#" color="primary" className="mr-2 mb-2">
                      <span className="fa fa-heart" /> Primary
                    </Badge>
                    <Badge
                      href="#"
                      color="secondary"
                      className="mr-2 mb-2 text-white"
                    >
                      <span className="fa fa-biohazard" /> Secondary
                    </Badge>
                    <Badge href="#" color="success" className="mr-2 mb-2">
                      <span className="fa fa-birthday-cake" /> Success
                    </Badge>
                    <Badge href="#" color="danger" className="mr-2 mb-2">
                      <span className="fa fa-blender" /> Danger
                    </Badge>
                    <Badge
                      href="#"
                      color="warning"
                      className="mr-2 mb-2 text-white"
                    >
                      <span className="fa fa-blind" /> Warning
                    </Badge>
                    <Badge href="#" color="info" className="mr-2 mb-2">
                      <span className="fa fa-blog" /> Info
                    </Badge>
                    <Badge
                      href="#"
                      color="light"
                      className="mr-2 mb-2 text-dark"
                    >
                      <span className="fa fa-bolt" /> Light
                    </Badge>
                    <Badge href="#" color="dark" className="mr-2 mb-2">
                      <span className="fa fa-bong" /> Dark
                    </Badge>
                    <Badge href="#" className="badge-reactify mr-2 mb-2">
                      <span className="fa fa-book-dead" /> Green
                    </Badge>
                    <Badge href="#" className="badge-aqua mr-2 mb-2">
                      <span className="fa fa-bookmark" /> Aqua
                    </Badge>
                    <Badge href="#" className="badge-brown mr-2 mb-2">
                      <span className="fa fa-box" /> Brown
                    </Badge>
                    <Badge href="#" className="badge-dark-blue mr-2 mb-2">
                      <span className="fa fa-box-open" /> Dark Blue
                    </Badge>
                    <Badge
                      href="#"
                      className="badge-light-green mr-2 mb-2 text-white"
                    >
                      <span className="fa fa-boxes" /> Light Green
                    </Badge>
                    <Badge href="#" className="badge-sea  mr-2 mb-2 text-white">
                      <span className="fa fa-braille" /> Turquoise
                    </Badge>
                    <Badge
                      href="#"
                      className="badge-orange mr-2 mb-2 text-white"
                    >
                      <span className="fa fa-brain" /> Orange
                    </Badge>
                    <Badge
                      href="#"
                      className="badge-yellow mr-2 mb-2 text-white"
                    >
                      <span className="fa fa-briefcase" /> Yellow
                    </Badge>
                  </Colxx>
                  <Colxx lg="6">
                    <p>
                      Default Badges: Easily highlight Without Icons or unread
                      items by adding a to links, Bootstrap navs, and more
                      please use <code>className="zero-radius"</code> for no
                      radius.
                    </p>{" "}
                    <Badge
                      href="#"
                      color="primary"
                      className="mr-2 mb-2 zero-radius"
                    >
                      1
                    </Badge>
                    <Badge
                      href="#"
                      color="secondary"
                      className="mr-2 mb-2 zero-radius text-white"
                    >
                      2
                    </Badge>
                    <Badge
                      href="#"
                      color="success"
                      className="mr-2 mb-2 zero-radius"
                    >
                      3
                    </Badge>
                    <Badge
                      href="#"
                      color="danger"
                      className="mr-2 mb-2 zero-radius"
                    >
                      4
                    </Badge>
                    <Badge
                      href="#"
                      color="warning"
                      className="mr-2 mb-2 text-white zero-radius"
                    >
                      5
                    </Badge>
                    <Badge
                      href="#"
                      color="info"
                      className="mr-2 mb-2 zero-radius"
                    >
                      6
                    </Badge>
                    <Badge
                      href="#"
                      color="light"
                      className="mr-2 mb-2 zero-radius text-dark"
                    >
                      7
                    </Badge>
                    <Badge
                      href="#"
                      color="dark"
                      className="mr-2 mb-2 zero-radius"
                    >
                      8
                    </Badge>
                    <p className="mt-3">
                      Rounded Default Badges: Easily highlight Without Icons or
                      unread items by adding a to links, Bootstrap navs, and
                      more .
                    </p>{" "}
                    <Badge href="#" color="primary" className="mr-2 mb-2">
                      1
                    </Badge>
                    <Badge
                      href="#"
                      color="secondary"
                      className="mr-2 mb-2 text-white"
                    >
                      2
                    </Badge>
                    <Badge href="#" color="success" className="mr-2 mb-2">
                      3
                    </Badge>
                    <Badge href="#" color="danger" className="mr-2 mb-2">
                      4
                    </Badge>
                    <Badge
                      href="#"
                      color="warning"
                      className="mr-2 mb-2 text-white"
                    >
                      5
                    </Badge>
                    <Badge href="#" color="info" className="mr-2 mb-2">
                      6
                    </Badge>
                    <Badge
                      href="#"
                      color="light"
                      className="mr-2 mb-2 text-dark"
                    >
                      7
                    </Badge>
                    <Badge
                      href="#"
                      color="dark"
                      className="mr-2 mb-2 zero-radius"
                    >
                      8
                    </Badge>
                  </Colxx>
                </Row>
              </CardBody>
            </Card>

            <Card className="mb-4">
              <CardBody>
                <CardTitle>
                  <IntlMessages id="button.with-badges" />
                </CardTitle>
                <Button
                  color="light"
                  className="btn btn-with-badge d-inline-flex align-items-center gap-2 me-2 mb-2"
                >
                  <span>Button</span>
                  <Badge color="primary" pill className="zero-radius">
                    8
                  </Badge>
                </Button>

                <Button
                  color="primary"
                  className="btn btn-with-badge d-inline-flex align-items-center gap-2 me-2 mb-2"
                >
                  <span>Button</span>
                  <Badge color="light" pill className="zero-radius text-dark">
                    10
                  </Badge>
                </Button>
                <Button
                  color="warning"
                  className="btn btn-with-badge d-inline-flex align-items-center gap-2 mb-2"
                >
                  <span>Button</span>
                  <Badge color="dark" pill className="zero-radius">
                    12
                  </Badge>
                </Button>
              </CardBody>
            </Card>

            {/* Content Sites */}
            <Card className="mb-4">
              <CardBody>
                <CardTitle>
                  <IntlMessages id="button.heading-badges" />
                </CardTitle>

                <h1>
                  Heading <Badge color="primary">New</Badge>
                </h1>
                <h2>
                  Heading <Badge color="primary">New</Badge>
                </h2>
                <h3>
                  Heading <Badge color="primary">New</Badge>
                </h3>
                <h4>
                  Heading <Badge color="primary">New</Badge>
                </h4>
                <h5>
                  Heading <Badge color="primary">New</Badge>
                </h5>
                <h6>
                  Heading <Badge color="primary">New</Badge>
                </h6>
              </CardBody>
            </Card>
            {/* Store Buttons */}
          </Colxx>
        </Row>
      </Fragment>
    );
}

export default badges;
